import type { z } from 'zod';
import type { ExpenditureBudgetPurposeSearchFormSchema } from '../models';

export const getBudgetPurposeSearchValues = (
  values: Partial<z.infer<typeof ExpenditureBudgetPurposeSearchFormSchema>>,
  isForm?: boolean,
): {
  accountingId: string;
  expenditureBudgetJurisdictionId: string;
  expenditureBudgetOrganizationId?: string;
  accountTitleId?: string;
} => {
  const isGeneral = !!values.expenditureBudgetOrganizationId;
  const accountingId = values.accountingId ?? '';
  const expenditureBudgetJurisdictionId =
    values.expenditureBudgetJurisdictionId ?? '';
  if (isGeneral) {
    return {
      accountingId,
      expenditureBudgetJurisdictionId,
      expenditureBudgetOrganizationId:
        values.expenditureBudgetOrganizationId ?? undefined,
      // The reason it is set to null is for error handling of the Form.
      ...(isForm ? { accountTitleId: null as any } : {}),
    };
  }
  return {
    accountingId,
    expenditureBudgetJurisdictionId,
    // The reason it is set to null is for error handling of the Form.
    ...(isForm ? { expenditureBudgetOrganizationId: null as any } : {}),
    ...(values.accountTitleId
      ? { accountTitleId: values.accountTitleId }
      : isForm
        ? { accountTitleId: null as any }
        : {}),
  };
};
